import { useEffect, useState } from "react";
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import AlertMessage from "../include/AlertMessage";
import ConfirmationPopup from "../include/ConfirmationPopup"; // ⬅️ Import new popup
import Pagination from "../Pagination";


var _ = require('lodash');

function Users() {
    const [alert, setAlert] = useState({ type: "", message: "" });
    const [allCustomers, setAllCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false); // popup state
    const [deleteId, setDeleteId] = useState(null); // store user id for delete
    const [deleting, setDeleting] = useState(false);

    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const currentPage = Number(searchParams.get("page")) || 1;
    const LIMIT = 10;

    const token = sessionStorage.getItem('JWT_TOKEN');


    const getAllCustomers = async (page = currentPage) => {
        try {
            setLoading(true);

            // List all users
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listallusers`, {
                params: {
                    page,
                    limit: LIMIT
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });

            const data = await response.data.data;

            if (Array.isArray(data) && data.length > 0 && Array.isArray(data)) {
                const finaldata = data;
                setAllCustomers(finaldata);

                setTotalPages(response.data.pagination.totalPages);
                setTotalRecords(response.data.pagination.total);
            } else {
                setAllCustomers([]);
            }
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.documentElement.className = "";

        getAllCustomers(currentPage);
    }, [currentPage]);


    const handleDelete = async () => {
        if (!deleteId) return;
        try {
            setLoading(true);
            setDeleting(true);
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/deleteuser/${deleteId}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token // Replace with your token
                    }
                }
            );

            if (response.status === 200 || response.status === 201) {

                const updatedData = allCustomers.filter(customer => customer.$id !== deleteId);

                setAllCustomers(updatedData);
                setAlert({ type: "success", message: "User deleted successfully!" });

                // ⭐ If page becomes empty go to previous page
                if (updatedData.length === 0 && currentPage > 1) {
                    setSearchParams({
                        page: currentPage - 1
                    });
                }


            }
            //getAllCustomers();
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setShowPopup(false); // close popup after action
            setDeleteId(null); // reset id
            setTimeout(() => {
                setLoading(false);
                setDeleting(false);
            }, 1000);
        }
    };

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li>All Users</li>
                    </ul>
                    <Link to="/user/add" className='button blue'>Add User</Link>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Users
                            </p>
                        </header>
                        <div className="card-content">
                            {alert.message && (
                                <AlertMessage
                                    type={alert.type}
                                    message={alert.message}
                                    onClose={() => setAlert({ type: "", message: "" })}
                                    duration={3000}
                                />
                            )}

                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>

                            ) : (
                                Array.isArray(allCustomers) && allCustomers.length > 0 ? (
                                    <>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th>Role</th>
                                                    <th>Created At</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(allCustomers || []).map((item, index) => (
                                                    <tr key={item.$id}>
                                                        <td data-label="Email">{item.email}</td>
                                                        <td data-label="Phone">{item.phone}</td>
                                                        <td data-label="Role">
                                                            {
                                                                Array.isArray(item.labels)
                                                                    ? item.labels
                                                                        .map(label =>
                                                                            label.charAt(0).toUpperCase() + label.slice(1)
                                                                        )
                                                                        .join(", ")
                                                                    : "N/A"
                                                            }
                                                        </td>
                                                        <td data-label={item.$createdAt?.split('T')[0]}>{item.$createdAt?.split('T')[0]}</td>
                                                        <td className="actions-cell">
                                                            <div className="buttons right nowrap">
                                                                {/* <Link to={`/customer/updatepass/${item.$id}`} className='button small blue' title='Update password'> <span className="icon"><i className="mdi mdi-key-variant"></i></span></Link> */}
                                                                <Link to={`/user/edit/${item.$id}?page=${currentPage}`} className='button small green' title='Update Customer'> <span className="icon"><i className="mdi mdi-pencil"></i></span></Link>
                                                                <button
                                                                    className="button small red"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        if (deleting) return;
                                                                        setDeleteId(item.$id);
                                                                        setShowPopup(true);
                                                                    }}
                                                                    style={{
                                                                        cursor: deleting ? "not-allowed" : "pointer",
                                                                        opacity: deleting ? 0.5 : 1
                                                                    }}
                                                                >
                                                                    <span className="icon"><i className="mdi mdi-trash-can"></i></span>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        {totalPages > 1 && (
                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                totalRecords={totalRecords}
                                                onPageChange={(page) =>
                                                    setSearchParams({
                                                        page
                                                    })
                                                }
                                            />
                                        )}
                                    </>
                                ) : (
                                    <p style={{ color: 'red', fontWeight: 'bold', textAlign: 'center' }}>No Record Found.</p>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* Confirmation Popup */}
            <ConfirmationPopup
                show={showPopup}
                onConfirm={handleDelete}
                onCancel={() => {
                    if (!deleting) {
                        setShowPopup(false);
                    }
                }}
                title="Confirm Delete"
                message={
                    deleting
                        ? "Deleting customer..."
                        : "Are you sure you want to delete this customer?"
                }
                deleting={deleting}
            />
        </section>
    );
};

export default Users;